import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgMail(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M1 5C1 3.89543 1.89543 3 3 3H21C22.1046 3 23 3.89543 23 5V6.94124L12.4534 11.8477C12.1659 11.9814 11.8341 11.9814 11.5466 11.8477L1 6.94123V5Z", fill: "currentColor" }),
        React.createElement("path", { d: "M1 8.98163V19C1 20.1046 1.89543 21 3 21H21C22.1046 21 23 20.1046 23 19V8.98163L13.2338 13.525C12.4515 13.889 11.5485 13.889 10.7662 13.525L1 8.98163Z", fill: "currentColor" })));
}
export default SvgMail;
